import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Box } from '@material-ui/core';

const CustomTabPanel = (props) => {
    const { children, isVisible, ...rest } = props;
    return isVisible && <Box {...rest}>{children}</Box>;
};

const CustomTabs = (props) => {
    const {
        headers, contents, tab, onChangeTab, customColor, ...rest
    } = props;

    const handleChange = (_, newValue) => {
        onChangeTab(newValue);
    };

    return (
        <>
            <Tabs value={tab} onChange={handleChange} indicatorColor="primary" {...rest}>
                {
                    // eslint-disable-next-line react/no-array-index-key
                    headers.map((header, index) => <Tab label={header} key={index} style={{ fontSize: '20px', color: props?.customColor }} />)
                }
            </Tabs>
            {
                // eslint-disable-next-line react/no-array-index-key
                contents.map((content, index) => <CustomTabPanel isVisible={tab === index}>{content}</CustomTabPanel>)
            }
        </>
    );
};

CustomTabPanel.defaultProps = {
    children: null,
};

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    isVisible: PropTypes.bool.isRequired,
};

CustomTabs.defaultProps = {
    contents: [],
    onChangeTab: null,
    customColor: '',
};

CustomTabs.propTypes = {
    headers: PropTypes.arrayOf(PropTypes.node).isRequired,
    contents: PropTypes.arrayOf(PropTypes.node),
    onChangeTab: PropTypes.func,
    tab: PropTypes.number.isRequired,
    customColor: PropTypes?.string,
};

export default CustomTabs;
